<template>
	<div>
		<div class="arp-botoes-listagem-itens-ata --flex-end">
			<div>
				<az-search
					:filter="filtro"
					simple-search-placeholder="Busque por: tipo, código e item."
					@simple-search="buscar"
					ref="componenteAzSearch"
					@remove-filter="removerFiltros"
				>
				</az-search>
			</div>
		</div>

		<acompanhamento-listagem
			v-if="listagem.datasource.length"
			:items="listagem.datasource"
			:paginacao="listagem.paginacao"
			:total-itens="listagem.totalItens"
			:total-paginas="listagem.totalPaginas"
			@paginar="setPaginacaoListagem"
		></acompanhamento-listagem>

		<az-container v-else>
			<template-listagem-vazia class="pb-4" :textos="texto" :total-iten="listagem.totalItens">
			</template-listagem-vazia>
		</az-container>
	</div>
</template>
<script>
import AcompanhamentoListagem from '@/views/pages/ata/acessar/gestao-da-ata/acompanhamento/listagem/AcompanhamentoListagem.vue'
import PaginacaoListagem from '@/core/store/default/paginacaoListagem'
import TemplateListagemVazia from '@/views/components/TemplateListagemVazia.vue'
import { actionTypes } from '@/core/constants'

export default {
	name: 'acessar-ata-acompanhamento-view',
	components: {
		TemplateListagemVazia,
		AcompanhamentoListagem,
	},
	data() {
		return {
			filtro: {
				tipoCodigoOuDescricao: '',
			},
			texto: { mensagem: 'Você não possui <strong>pedido adicionado</strong>' },
			listagem: {
				datasource: [],
				totalPaginas: 1,
				totalItens: 0,
				paginacao: PaginacaoListagem(['codigo'], 25),
			},
		}
	},
	async created() {
		await this.loadData()
	},
	methods: {
		async loadData() {
			try {
				const { itens, totalElements, totalPages } = await this.$store.dispatch(
					actionTypes.ATA.ACOMPANHAMENTO.BUSCAR_POR_FILTRO,
					{ filtros: this.filtro, idAta: this.$route.params.id, paginacao: this.listagem.paginacao },
				)
				this.listagem.datasource = itens
				this.listagem.totalItens = totalElements
				this.listagem.totalPaginas = totalPages
			} catch (Err) {
				throw new Error(Err)
			}
		},
		async buscar(searchText) {
			this.filtro.tipoCodigoOuDescricao = searchText !== null ? searchText : ''
			this.listagem.paginacao.page = 1
			await this.loadData()
		},
		async removerFiltros() {
			if (this.filtro) this.filtro = { filtro: '' }
			await this.loadData()
		},
		setPaginacaoListagem() {
			this.loadData()
		},
	},
}
</script>
<style lang="stylus" scoped>
.arp-botoes-listagem-itens-ata
	display flex;
	margin 25px 0
	place-content: space-between

.--flex-end
	place-content: flex-end

	> div
		margin-right 15px

.d-flex
	gap: 10px
</style>
